import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

export const routes = {
  documentTypesPath: () => '/api/DocumentTypes',
  documentTypesGridPath: (data) => `/api/DocumentTypes/Grid/${getQueryParams(data)}`,
};

export const getDocumentTypes = () => makeRequest(
  authFetch.get(routes.documentTypesPath()),
);

export const getDocumentTypesGrid = (data) => makeRequest(
  authFetch.get(routes.documentTypesGridPath(data)),
);

export const postDocumentType = (documentType) => makeRequest(
  authFetch.put(routes.documentTypesPath(), documentType),
);
